/**
 * @generated SignedSource<<6ca60f544c0e98ee41d002ba5f94f860>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventVisibility = "cohort" | "member_group" | "public" | "%future added value";
export type OccurrenceStatus = "draft" | "published" | "%future added value";
export type OccurrencesOrderBy = "event_name" | "feedback" | "recording_watch_progress" | "start_date" | "%future added value";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type OrganizationOccurrencesDatetimeFilter = "past" | "upcoming" | "%future added value";
export type ContentUsageFormEventsFieldQuery$variables = {
  after?: string | null;
  datetimeFilter?: OrganizationOccurrencesDatetimeFilter | null;
  direction?: OrderDirection | null;
  first: number;
  id: string;
  orderBy?: OccurrencesOrderBy | null;
  productId: string;
  search?: string | null;
  selectedIds?: ReadonlyArray<string> | null;
};
export type ContentUsageFormEventsFieldQuery$data = {
  readonly organization: {
    readonly id?: string;
    readonly occurrences?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly content: {
            readonly name: string | null;
          };
          readonly datetimeRange: ReadonlyArray<string>;
          readonly id: string;
          readonly status: OccurrenceStatus;
          readonly visibility: EventVisibility;
          readonly " $fragmentSpreads": FragmentRefs<"OccurrenceNameAndTimeFragment">;
        };
      }>;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
        readonly hasPreviousPage: boolean;
        readonly startCursor: string | null;
      };
    };
    readonly selectedOccurrences?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly content: {
            readonly name: string | null;
          };
          readonly datetimeRange: ReadonlyArray<string>;
          readonly id: string;
          readonly status: OccurrenceStatus;
          readonly visibility: EventVisibility;
          readonly " $fragmentSpreads": FragmentRefs<"OccurrenceNameAndTimeFragment">;
        };
      }>;
    };
  } | null;
};
export type ContentUsageFormEventsFieldQuery = {
  response: ContentUsageFormEventsFieldQuery$data;
  variables: ContentUsageFormEventsFieldQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "datetimeFilter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "direction"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "selectedIds"
},
v9 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v11 = {
  "kind": "Variable",
  "name": "direction",
  "variableName": "direction"
},
v12 = {
  "items": [
    {
      "kind": "Variable",
      "name": "includedProductIds.0",
      "variableName": "productId"
    }
  ],
  "kind": "ListValue",
  "name": "includedProductIds"
},
v13 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v14 = [
  (v11/*: any*/),
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "selectedIds"
  },
  (v12/*: any*/),
  (v13/*: any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "datetimeRange",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "OccurrenceNodeEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Occurrence",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v18/*: any*/)
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "OccurrenceNameAndTimeFragment"
        },
        (v19/*: any*/)
      ],
      "storageKey": null
    },
    (v20/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endCursor",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfoObjectType",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v22/*: any*/),
    (v23/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "kind": "Variable",
  "name": "datetimeFilter",
  "variableName": "datetimeFilter"
},
v26 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v27 = {
  "kind": "Literal",
  "name": "status",
  "value": "published"
},
v28 = {
  "kind": "Literal",
  "name": "visibility",
  "value": [
    "cohort",
    "public",
    "member_group"
  ]
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfoObjectType",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v23/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    },
    (v22/*: any*/)
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "OccurrenceNodeEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Occurrence",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Content",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            (v10/*: any*/)
          ],
          "storageKey": null
        },
        (v18/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Event",
          "kind": "LinkedField",
          "name": "event",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isRecurring",
              "storageKey": null
            },
            (v10/*: any*/)
          ],
          "storageKey": null
        },
        (v19/*: any*/)
      ],
      "storageKey": null
    },
    (v20/*: any*/)
  ],
  "storageKey": null
},
v31 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  (v25/*: any*/),
  (v11/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v12/*: any*/),
  (v13/*: any*/),
  (v26/*: any*/),
  (v27/*: any*/),
  (v28/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ContentUsageFormEventsFieldQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*: any*/),
              {
                "alias": "selectedOccurrences",
                "args": (v14/*: any*/),
                "concreteType": "OccurrenceNodeConnection",
                "kind": "LinkedField",
                "name": "__ContentUsageFormEventsField__selectedOccurrences_connection",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "occurrences",
                "args": [
                  (v25/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/)
                ],
                "concreteType": "OccurrenceNodeConnection",
                "kind": "LinkedField",
                "name": "__ContentUsageFormEventsField__occurrences_connection",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v29/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v8/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ContentUsageFormEventsFieldQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v9/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v19/*: any*/),
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": "selectedOccurrences",
                "args": (v14/*: any*/),
                "concreteType": "OccurrenceNodeConnection",
                "kind": "LinkedField",
                "name": "occurrences",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "selectedOccurrences",
                "args": (v14/*: any*/),
                "filters": [
                  "ids",
                  "includedProductIds",
                  "orderBy",
                  "direction"
                ],
                "handle": "connection",
                "key": "ContentUsageFormEventsField__selectedOccurrences",
                "kind": "LinkedHandle",
                "name": "occurrences"
              },
              {
                "alias": null,
                "args": (v31/*: any*/),
                "concreteType": "OccurrenceNodeConnection",
                "kind": "LinkedField",
                "name": "occurrences",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  (v29/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v31/*: any*/),
                "filters": [
                  "search",
                  "status",
                  "visibility",
                  "includedProductIds",
                  "datetimeFilter",
                  "orderBy",
                  "direction"
                ],
                "handle": "connection",
                "key": "ContentUsageFormEventsField__occurrences",
                "kind": "LinkedHandle",
                "name": "occurrences"
              }
            ],
            "type": "Organization",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "85185f4563e0276413963ababed7bba3",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": null,
          "cursor": null,
          "direction": "forward",
          "path": [
            "organization",
            "selectedOccurrences"
          ]
        },
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "organization",
            "occurrences"
          ]
        }
      ]
    },
    "name": "ContentUsageFormEventsFieldQuery",
    "operationKind": "query",
    "text": "query ContentUsageFormEventsFieldQuery(\n  $id: ID!\n  $selectedIds: [ID!]\n  $productId: ID!\n  $first: Int!\n  $after: String\n  $search: String\n  $datetimeFilter: OrganizationOccurrencesDatetimeFilter\n  $orderBy: OccurrencesOrderBy\n  $direction: OrderDirection\n) {\n  organization: node(id: $id) {\n    __typename\n    ... on Organization {\n      id\n      selectedOccurrences: occurrences(ids: $selectedIds, includedProductIds: [$productId], orderBy: $orderBy, direction: $direction) {\n        edges {\n          node {\n            id\n            status\n            datetimeRange\n            visibility\n            content {\n              name\n              id\n            }\n            ...OccurrenceNameAndTimeFragment\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n      occurrences(first: $first, after: $after, search: $search, status: published, visibility: [cohort, public, member_group], includedProductIds: [$productId], datetimeFilter: $datetimeFilter, orderBy: $orderBy, direction: $direction) {\n        edges {\n          node {\n            id\n            status\n            datetimeRange\n            visibility\n            content {\n              name\n              id\n            }\n            ...OccurrenceNameAndTimeFragment\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          hasNextPage\n          hasPreviousPage\n          startCursor\n          endCursor\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment OccurrenceNameAndTimeFragment on Occurrence {\n  id\n  name\n  datetimeRange\n  event {\n    isRecurring\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "02add80faf26b69e634b1d9e13e8fdc3";

export default node;
